import { useModalState } from "@clipboard-health/ui-components";
import { type ShiftInvite } from "@src/appV2/redesign/WorkerShifts/ShiftInvites/types";
import constate from "constate";
import { useState } from "react";

import { type Shift } from "../../../../Shifts/Shift/types";

function useShiftInviteItem() {
  const [conflictingShift, setConflictingShift] = useState<Shift>();
  const [conflictingInvites, setConflictingInvites] = useState<ShiftInvite[]>([]);
  const conflictingShiftDialogState = useModalState();
  const conflictingInviteDialogState = useModalState();
  const overworkingShiftDialogState = useModalState();
  const missingFacilityRequiredDocumentsDialogState = useModalState();
  const missingCoreRequiredDocumentsDialogState = useModalState();
  const weeklyHoursLimitExceededDialogState = useModalState();
  const locationPermissionsModalState = useModalState();
  const arrivalTimeModalState = useModalState();
  const confirmShiftBookingModalState = useModalState();
  const [missingDocuments, setMissingDocuments] = useState<string[]>([]);
  const [weeklyHoursLimit, setWeeklyHoursLimit] = useState<number>(0);
  const [shouldDeclineConflictingInvites, setShouldDeclineConflictingInvites] = useState(false);
  const [skipFacilityRequiredDocumentCheck, setSkipFacilityRequiredDocumentCheck] = useState(false);
  const [isOverworkingShiftsAllowed, setIsOverworkingShiftsAllowed] = useState(false);

  const resetWarnings = () => {
    setShouldDeclineConflictingInvites(false);
    setSkipFacilityRequiredDocumentCheck(false);
    setIsOverworkingShiftsAllowed(false);
  };

  return {
    conflictingShift,
    setConflictingShift,
    conflictingInvites,
    setConflictingInvites,
    shouldDeclineConflictingInvites,
    setShouldDeclineConflictingInvites,
    skipFacilityRequiredDocumentCheck,
    setSkipFacilityRequiredDocumentCheck,
    isOverworkingShiftsAllowed,
    setIsOverworkingShiftsAllowed,
    resetWarnings,
    conflictingShiftDialogState,
    conflictingInviteDialogState,
    overworkingShiftDialogState,
    missingFacilityRequiredDocumentsDialogState,
    missingCoreRequiredDocumentsDialogState,
    locationPermissionsModalState,
    arrivalTimeModalState,
    confirmShiftBookingModalState,
    missingDocuments,
    setMissingDocuments,
    weeklyHoursLimitExceededDialogState,
    weeklyHoursLimit,
    setWeeklyHoursLimit,
  };
}

export const [ShiftInviteItemProvider, useShiftInviteItemContext] = constate(useShiftInviteItem);
